import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../../../shared/shared.module';

import { WithdrawalsComponent } from './components/withdrawals/withdrawals.component';
import { ActivationComponent } from './components/activation/activation.component';
import { ContractsComponent } from './components/contracts/contracts.component';
import { BankAccountsComponent } from './components/bank-accounts/bank-accounts.component';
import { SmsMarketingRequestsComponent } from './components/sms-marketing-requests/sms-marketing-requests.component';
import { OtlobXPostRequestComponent } from './components/otlob-x-post-request/otlob-x-post-request.component';


const reportRoutes: Routes = [
  { path: 'reports/withdrawals', component: WithdrawalsComponent },
  { path: 'postRequest', component: OtlobXPostRequestComponent },
  { path: 'ActivationRequest', component: ActivationComponent },
  { path: 'contracts', component: ContractsComponent },
  { path: 'bankAccounts', component: BankAccountsComponent },
  { path: 'sms-marketing', component: SmsMarketingRequestsComponent}
];

@NgModule({
  declarations: [
    WithdrawalsComponent,
    OtlobXPostRequestComponent,
    ActivationComponent,
    ContractsComponent,
    BankAccountsComponent,
    SmsMarketingRequestsComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(reportRoutes),
    SharedModule
  ],
  providers: [
  ]
})
export class RequestModule { }
